module.exports = __webpack_public_path__ + "static/jobData-a0ba4555d7abd9484d0abf16fc4a461f.jpg";